import { clsModel, fnCreate } from '@cls/clsModel'
import { disputes as api } from '@/app/api'

var modelName = "dispute";
const fields = ['id', 'name'];

class clsDispute extends clsModel {

    name = null;
    
    get modelRep() {
        return this.name;
    }
    
    
    constructor() {
        super({
          api: api,   
          modelName: modelName, 
          mandatoryFields: ['name'],

          fillable: fields
        })
    } 
        
 }
 export default fnCreate(clsDispute , 'clsDispute');
